module.exports = __webpack_public_path__ + "static/img/Jack-Macrae.5eaf97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Macrae.jpg
// module id = B1c6
// module chunks = 0